import { render, staticRenderFns } from "./TemplateInteractions.vue?vue&type=template&id=21c098db&scoped=true"
import script from "./TemplateInteractions.vue?vue&type=script&lang=js"
export * from "./TemplateInteractions.vue?vue&type=script&lang=js"
import style0 from "./TemplateInteractions.vue?vue&type=style&index=0&id=21c098db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c098db",
  null
  
)

export default component.exports